import React, { createContext, useContext, useState, ReactNode } from "react";

interface AppContextType {
  exid: string | null;
  timestamp: string | null;
  setExid: (exid: string | null) => void;
  setTimestamp: (timestamp: string | null) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [exid, setExid] = useState<string | null>(null);
  const [timestamp, setTimestamp] = useState<string | null>(null);

  const value = {
    exid,
    timestamp,
    setExid,
    setTimestamp,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
